<template>
  <div class="wrapper">
    <v-container>
      <v-row>
        <v-col>
          <slot></slot>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Wrapper',
}
</script>

<style>
.wrapper {
  margin: 20px;
  /* background: #ffffff; */
  border-radius: 20px;
  /* border: 0.5px solid #aaa; */
}
</style>